import React from 'react';

import ScaleHead from 'react-scale/components/ui/head';
import Loading from 'react-scale/components/ui/loading';

const Head = ({ title, description, canonical }) => (
  <>
    <ScaleHead
      title={title}
      description={description}
      canonical={canonical}
      ogImg="https://scale.com/static/img/website/docs/social/fb.png"
      twImg="https://scale.com/static/img/website/docs/social/tw.png"
    />
    <Loading />
  </>
);

export default Head;
